import { useMemo } from 'react'
import { useSelector, shallowEqual } from 'react-redux'

import { Allowance } from './useReportAllowances'
import { DetailsGroup, useReportDetailsGroup } from './useReportDetailsGroup'


export type TotalsDto = {
  allowances: Record<Allowance, number>
  totalCommon: number
  total: number
}

export function useReportTotalsDto() {
  const totals = useSelector((state: any) => state.reports.subsidies.data.totals, shallowEqual)
  const summary = useSelector((state: any) => state.reports.subsidies.data.summary, shallowEqual)
  const detailsGroup = useReportDetailsGroup()

  const res = useMemo(() => {
    if (totals && detailsGroup === DetailsGroup.ByAllowances && summary) {
      const { total, total_common: totalCommon } = summary
      return { ...totals, total, totalCommon } as TotalsDto
    }
    return null
  }, [totals, summary, detailsGroup])

  return res
}
